import classNames from 'classnames';

import {CURATORS_ONLY, EVERYONE, FULL_ACCESS_USER_LABEL, cardPermissions} from '../../modules/constants/permissions';
import Icon from '../_icon';

const CardVisibilityGroups = ({card, previewingId}) => {
  const {isDraft, allAccess, visibilityGroups} = card;
  const everyoneEnabled = !isDraft && allAccess;
  const groupsEnabled = !isDraft && !allAccess;

  const getIcon = () => {
    if(isDraft) {
      return 'visibility-off';
    }

    if(allAccess) {
      return 'visibility-on';
    }

    return 'people';
  };

  // eslint-disable-next-line react/no-multi-comp
  const getListItems = () => {
    if(isDraft) {
      return (<li data-test-id="card-visibility-groups--draft">{cardPermissions[CURATORS_ONLY].label}</li>);
    }

    if(allAccess) {
      return (<li data-test-id="card-visibility-groups--allAccess">{cardPermissions[EVERYONE].label}</li>);
    }

    if((visibilityGroups || []).length) {
      return visibilityGroups
        .reduce((acc, group) => {
          if(group.id === previewingId) {
            acc.unshift(group);
          }
          else {
            acc.push(group);
          }

          return acc;
        }, [])
        .map(({name, id}, i) => (
          <li data-test-id="`card-visibility-groups-list_${id}`" key={id}>
            {`${name}${(i < (visibilityGroups.length - 1)) ? ', ' : ''}`}
          </li>
        ));
    }

    return (<li>{FULL_ACCESS_USER_LABEL}</li>);
  };

  return (
    <div data-test-id="card-visibility-groups"
      className={classNames('card-visibility-groups', {
        'card-visibility-groups--draft': isDraft,
        'card-visibility-groups--allAccess': everyoneEnabled,
        'card-visibility-groups--groups': groupsEnabled
      })}>
      <Icon data-test-id="card-visibility-groups-icon" icon={getIcon()} className="card-visibility-groups-icon" />
      <ul data-test-id="card-visibility-groups-list">
        {getListItems()}
      </ul>
    </div>
  );
};

CardVisibilityGroups.propTypes = {
  card: PropTypes.object,
  previewingId: PropTypes.number
};

CardVisibilityGroups.defaultProps = {
  card: {},
  previewingId: null
};

export default CardVisibilityGroups;
